//кнопка вверх
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(document).scrollTop() > 10) {
      $('#scroll').css('display', 'block');
    }
    else {
      $('#scroll').css('display', 'none');
    }
  });
  $('#toTop').click(function () {
    $('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
    return false;
  });
});

if (document.getElementsByClassName('image-text-link').length > 0) {
  $('.image-text-link').magnificPopup({type: 'image'});
}

//слайдер партнеры
$('.reviews-slider').slick({
  dots: false,
  infinite: true,
  speed: 1000,
  autoplay: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
});


//mobile filtr
$('.filtr-button').click(function () {
  console.log(88);
  if($('.all-filtres').hasClass('openFiltr')) {
    $('.all-filtres').removeClass('openFiltr');
  }
  else {
    $('.all-filtres').addClass('openFiltr');
  }
});

//popup message
// let num = 1;
// setTimeout(function () {
//   if (num < 3) {
//     $(".message-popup-new").addClass('open');
//     setTimeout(function () {
//       $(".message-popup-new").removeClass('open');
//       num++
//       if (num <= 1) {
//         openPopup();
//       }
//
//     }, 10000);
//   }
//
// }, 10000);
//
// $('.message-popup-new .close-popup, .message-popup-new .wind-bg').click(function () {
//   $(".message-popup-new").removeClass('open');
//   num++
//   if (num <= 1) {
//     openPopup();
//   }
// });
//
// function openPopup() {
//   setTimeout(function () {
//
//     $(".message-popup-new").addClass('open');
//
//     if (num < 3) {
//       setTimeout(function () {
//         num++
//         openPopup();
//       }, 10000);
//     }
//     setTimeout(function () {
//       $(".message-popup-new").removeClass('open');
//     }, 10000);
//
//   }, 60000);
// }


//popup message
let num = 1;
setTimeout(function () {
  if (num < 3) {
    $(".message-popup").addClass('open');
    setTimeout(function () {
      $(".message-popup").removeClass('open');
      num++
      if (num <= 3) {
        openPopup();
      }

    }, 10000);
  }

}, 10000);

$('.message-popup .close-popup, .message-popup .wind-bg').click(function () {
  $(".message-popup").removeClass('open');
  num++
  if (num <= 3) {
    openPopup();
  }
});

function openPopup() {
  setTimeout(function () {

    $(".message-popup").addClass('open');

    if (num < 3) {
      setTimeout(function () {
        num++
        openPopup();
      }, 10000);
    }
    setTimeout(function () {
      $(".message-popup").removeClass('open');
    }, 10000);

  }, 60000);
}


// WEBPACK FOOTER //
// ./resources/js/snippets/common.js